module.exports = __webpack_public_path__ + "img/defaultAvatar.d8a851d0.jpeg";